import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@tytapp/user';
import { ApiCommunicationPref, ApiUser, CommunicationPrefsApi } from '@tytapp/api';
import { SubSink } from 'subsink';


@Component({
    selector: 'tyt-notifications-settings',
    templateUrl: './notifications-settings.component.html',
    styleUrls: ['./notifications-settings.component.scss']
})
export class NotificationsSettingsComponent implements OnInit, OnDestroy {
    constructor(
        private userService: UserService,
        private commPrefsApi: CommunicationPrefsApi
    ) { }

    subsink = new SubSink();
    user: ApiUser;
    prefs: ApiCommunicationPref[];
    prefValues: boolean[];

    ngOnInit() {
        this.subsink.add(this.userService.userChanged.subscribe(u => this.user = u));

        this.subsink.add(this.commPrefsApi.getCommunicationPrefs()
            .subscribe(res => {
                this.prefs = res.filter(pref => pref.category === 'notification');
                this.prefValues = this.prefs.map(({ allowed }) => allowed);
            }));
    }

    async saveChanges() {
        const patch = this.prefs.filter(({ allowed }, i) => allowed !== this.prefValues[i]);
        if (patch.length) {
            patch.forEach(pref => pref.allowed = !pref.allowed);
            await this.commPrefsApi.patchCommunicationPrefs({
                communication_prefs: patch
            }).toPromise();
        }
    }

    ngOnDestroy() {
        this.subsink.unsubscribe();
    }
}
